<template>
  <div class="list-box" style="padding: 10px 0">
    <ul class="list-search">
      <el-config-provider
        :value-on-clear="null"
        :empty-values="[undefined, null]"
      >
        <el-space wrap>
          <el-input
            v-model="state.params.keywords"
            style="width: 200px"
            placeholder="姓名、证件号、手机号"
            clearable
            @clear="
              delete state.params.keywords;
              onLoad();
            "
            @paste.enter="$onKeywordsPaste($event, state.params)"
          ></el-input>
          <c_withholdingagentselectgroup
            @confirm="
              (item) => {
                state.params.withholding_agent_type = item.type;
                state.params.withholding_agent_id = item.ids;
              }
            "
            :key="state.key"
          ></c_withholdingagentselectgroup>
          <el-select
            v-model="state.declare_status"
            multiple
            placeholder="报送状态"
            collapse-tags
            collapse-tags-tooltip
            :max-collapse-tags="1"
            style="width: 200px"
            @clear="delete state.declare_status"
          >
            <el-option
              v-for="item in $constant.employeedeclare_declare_status"
              :key="item.Key"
              :label="item.Text"
              :value="item.Key"
            />
          </el-select>
          <c_statusselect
            v-model="state.params.tax_status"
            arrName="payrollemployee_tax_status"
            placeholder="算税状态"
            style="width: 120px"
            @change="onLoad"
            :key="state.key"
          ></c_statusselect>
          <c_statusselect
            v-model="state.params.pay_status"
            arrName="payrollemployee_pay_status"
            placeholder="发放状态"
            style="width: 120px"
            @change="onLoad"
            :key="state.key"
          ></c_statusselect>
          <el-select
            v-model="state.params.is_need_re_calc_tax"
            placeholder="是否需重新算税"
            style="width: 160px"
            @change="onLoad"
          >
            <el-option label="需要重新算税" :value="1" />
            <el-option label="无需重新算税" :value="0" />
          </el-select>
          <el-select
            v-model="state.params.job_status"
            placeholder="在职状态"
            style="width: 120px"
            @change="onLoad"
          >
            <el-option label="在职" :value="1" />
            <el-option label="离职" :value="0" />
          </el-select>
          <el-dropdown split-button @click="onLoad" type="primary">
            查询
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item :icon="RefreshLeft" @click="onReset()">
                  重置
                </el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
        </el-space>
      </el-config-provider>
    </ul>
    <div
      style="
        border: 1px solid var(--el-border-color-lighter);
        padding: 10px;
        border-bottom: 0;
        display: flex;
        align-items: center;
        justify-content: flex-end;
      "
    >
      <li style="flex: 1">
        <el-button
          v-if="$judge_auth('673')"
          type="primary"
          round
          @click="state.showImport = true"
        >
          1.导入
        </el-button>
        <el-button
          round
          @click="
            onClearParams();
            state.params.job_status = 0;
            onLoad();
          "
        >
          2.离职检查
        </el-button>
        <el-button
          v-if="$judge_auth('668')"
          round
          type="warning"
          @click="onEdits"
        >
          3.批量编辑员工
        </el-button>
        <el-button
          round
          @click="
            onClearParams();
            state.declare_status = [0, 2];
            onLoad();
          "
        >
          4.报送检查
        </el-button>
        <el-button
          v-if="$judge_auth('669')"
          round
          type="warning"
          @click="onDeclares"
        >
          5.批量报送员工
        </el-button>
        <el-button
          v-if="$judge_auth('670')"
          round
          type="success"
          @click="onSuanShui"
          >6.申请算税
          <text
            v-if="$judge_auth('67')"
            style="text-decoration: underline"
            @click.stop="toSuanShui"
          >
            {{ state.taxCount ? "(" + state.taxCount + ")" : "" }}
          </text>
          <text v-else>
            {{ state.taxCount ? "(" + state.taxCount + ")" : "" }}
          </text>
        </el-button>
        <el-button
          round
          type="primary"
          @click="state.showYhdk = true"
          v-if="$judge_auth('665')"
          >7.认领到款</el-button
        >
        <el-button v-if="$judge_auth('671')" round type="danger" @click="onPay"
          >8.申请发薪
          <text
            v-if="$judge_auth('110')"
            style="text-decoration: underline"
            @click.stop="toFaXin"
          >
            {{ state.payCount ? "(" + state.payCount + ")" : "" }}
          </text>
          <text v-else>
            {{ state.payCount ? "(" + state.payCount + ")" : "" }}
          </text>
        </el-button>
      </li>
      <div
        style="
          line-height: 30px;
          color: #a2a2a2;
          margin-right: 10px;
          white-space: nowrap;
        "
      >
        已选择：<strong style="color: #f00">{{ state.selectIds.length }}</strong
        >条数据
      </div>
      <div style="display: flex; overflow-x: auto">
        <el-button
          link
          type="warning"
          icon="Close"
          @click="onCanelSuanShui"
          v-if="$judge_auth('666')"
          >取消算税
        </el-button>
        <el-button
          v-if="$judge_auth('667')"
          link
          type="danger"
          icon="Delete"
          @click="onDeletes"
        >
          批量删除
        </el-button>
        <!-- <el-button link type="primary" icon="Edit" @click="onShowSetAgent">
          设置扣缴义务人
        </el-button> -->
        <el-button
          v-if="$judge_auth('672')"
          link
          type="danger"
          icon="Warning"
          @click="state.showError = true"
          >异常处理
          {{ state.errorCount ? "(" + state.errorCount + ")" : "" }}
        </el-button>
        <el-button
          v-if="$judge_auth('674')"
          type="primary"
          :icon="Upload"
          link
          @click="onExport"
        >
          导出
        </el-button>
      </div>
    </div>
    <div
      style="flex: 1; display: flex; flex-direction: column; overflow: hidden"
    >
      <div
        class="table-container"
        v-loading="!Array.isArray(state.tableData)"
        element-loading-background="rgba(0, 0, 0, 0.2)"
      >
        <table
          cellpadding="10"
          cellspacing="0"
          v-if="Array.isArray(state.tableData)"
        >
          <thead>
            <tr>
              <th style="white-space: nowrap">
                <input type="checkbox" id="all" @change="onAllChecked" />
              </th>
              <th style="white-space: nowrap">
                <div style="width: 50px">序号</div>
              </th>
              <th
                style="white-space: nowrap"
                :data-width="state.column_name_width"
              >
                姓名
                <el-tooltip
                  effect="dark"
                  content="姓名为红色字体表示需要重新算税"
                  placement="top-start"
                >
                  <el-icon style="cursor: pointer"><QuestionFilled /></el-icon>
                </el-tooltip>
              </th>
              <th
                style="white-space: nowrap; text-align: center"
                @click="onSortChange('tax_status')"
              >
                <div
                  style="display: flex; align-items: center; cursor: pointer"
                >
                  算税状态
                  <div
                    style="
                      display: flex;
                      flex-direction: column;
                      margin-left: 3px;
                    "
                  >
                    <el-icon
                      :size="12"
                      style="height: 6px"
                      :color="
                        state.params.sort_field == 'tax_status' &&
                        state.params.sort_value == 'asc'
                          ? '#1e90ff'
                          : ''
                      "
                      ><CaretTop
                    /></el-icon>
                    <el-icon
                      :size="12"
                      style="height: 6px"
                      :color="
                        state.params.sort_field == 'tax_status' &&
                        state.params.sort_value == 'desc'
                          ? '#1e90ff'
                          : ''
                      "
                    >
                      <CaretBottom />
                    </el-icon>
                  </div>
                </div>
              </th>
              <th
                style="white-space: nowrap"
                @click="onSortChange('pay_status')"
              >
                <div
                  style="display: flex; align-items: center; cursor: pointer"
                >
                  发放状态
                  <div
                    style="
                      display: flex;
                      flex-direction: column;
                      margin-left: 3px;
                    "
                  >
                    <el-icon
                      :size="12"
                      style="height: 6px"
                      :color="
                        state.params.sort_field == 'pay_status' &&
                        state.params.sort_value == 'asc'
                          ? '#1e90ff'
                          : ''
                      "
                      ><CaretTop
                    /></el-icon>
                    <el-icon
                      :size="12"
                      style="height: 6px"
                      :color="
                        state.params.sort_field == 'pay_status' &&
                        state.params.sort_value == 'desc'
                          ? '#1e90ff'
                          : ''
                      "
                    >
                      <CaretBottom />
                    </el-icon>
                  </div>
                </div>
              </th>
              <th
                style="white-space: nowrap"
                @click="onSortChange('declare_status')"
              >
                <div
                  style="display: flex; align-items: center; cursor: pointer"
                >
                  报送状态
                  <div
                    style="
                      display: flex;
                      flex-direction: column;
                      margin-left: 3px;
                    "
                  >
                    <el-icon
                      :size="12"
                      style="height: 6px"
                      :color="
                        state.params.sort_field == 'declare_status' &&
                        state.params.sort_value == 'asc'
                          ? '#1e90ff'
                          : ''
                      "
                      ><CaretTop
                    /></el-icon>
                    <el-icon
                      :size="12"
                      style="height: 6px"
                      :color="
                        state.params.sort_field == 'declare_status' &&
                        state.params.sort_value == 'desc'
                          ? '#1e90ff'
                          : ''
                      "
                    >
                      <CaretBottom />
                    </el-icon>
                  </div>
                </div>
              </th>
              <th style="white-space: nowrap">扣缴义务人</th>
              <template
                v-for="item in state.templateSortFields.filter(
                  (w) => !state.hideColumns.includes(w.name),
                )"
                :key="item"
              >
                <th v-if="item.field == 'idcard'" style="white-space: nowrap">
                  <div
                    style="
                      resize: horizontal;
                      overflow-x: auto;
                      min-width: 100px;
                    "
                  >
                    {{ item.name }}
                    <el-icon
                      title="单机复制整列"
                      style="cursor: pointer"
                      @click="onCopyColumns(item.field)"
                    >
                      <DocumentCopy />
                    </el-icon>
                  </div>
                </th>
                <th v-else style="white-space: nowrap">
                  <div
                    style="
                      resize: horizontal;
                      overflow-x: auto;
                      min-width: 100px;
                    "
                  >
                    {{ item.name }}
                  </div>
                </th>
              </template>

              <th style="text-align: center" v-if="$judge_auth(['667', '668'])">
                操作
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="row in state.tableData"
              :key="row"
              @click="onRowClick(row.id)"
            >
              <td>
                <input
                  type="checkbox"
                  :id="row.id"
                  :key="state.key"
                  :checked="state.selectIds?.includes(row.id)"
                />
              </td>
              <td style="white-space: nowrap">
                <div style="width: 50px; text-align: left">{{ row.sn }}</div>
              </td>
              <td
                style="white-space: nowrap; display: flex; align-items: center"
                :data-width="state.column_name_width"
              >
                <el-tooltip
                  effect="dark"
                  content="该员工需要重新算税"
                  placement="top-start"
                  v-if="row.is_need_re_calc_tax"
                >
                  <text style="cursor: pointer; color: #f00">
                    {{ row.name }}
                  </text>
                </el-tooltip>
                <text v-else>{{ row.name }}</text>
              </td>
              <td style="white-space: nowrap">
                <el-tooltip
                  effect="dark"
                  :content="row.tax_failure_msg"
                  v-if="row.tax_failure_msg"
                >
                  <div
                    style="
                      display: flex;
                      align-items: center;
                      justify-content: center;
                      cursor: pointer;
                    "
                  >
                    <c_status
                      arrName="payrollemployee_tax_status"
                      :value="row.tax_status"
                    />
                    <el-icon><QuestionFilled /></el-icon>
                  </div>
                </el-tooltip>
                <c_status
                  arrName="payrollemployee_tax_status"
                  :value="row.tax_status"
                  style="margin: 0 auto"
                  v-else
                ></c_status>
              </td>
              <td style="white-space: nowrap">
                <el-tooltip
                  effect="dark"
                  :content="row.pay_failure_msg"
                  v-if="row.pay_failure_msg"
                >
                  <div
                    style="
                      display: flex;
                      align-items: center;
                      justify-content: center;
                      cursor: pointer;
                    "
                  >
                    <c_status
                      arrName="payrollemployee_pay_status"
                      :value="row.pay_status"
                    />
                    <el-icon><QuestionFilled /></el-icon>
                  </div>
                </el-tooltip>
                <c_status
                  arrName="payrollemployee_pay_status"
                  :value="row.pay_status"
                  style="margin: 0 auto"
                  v-else
                ></c_status>
              </td>
              <td style="white-space: nowrap">
                <el-tooltip
                  effect="dark"
                  :content="row.declare_failure_msg"
                  v-if="row.declare_failure_msg"
                >
                  <div
                    style="
                      display: flex;
                      align-items: center;
                      justify-content: center;
                      cursor: pointer;
                    "
                  >
                    <c_status
                      arrName="employeedeclare_declare_status"
                      :value="row.declare_status"
                    />
                    <el-icon><QuestionFilled /></el-icon>
                  </div>
                </el-tooltip>
                <c_status
                  arrName="employeedeclare_declare_status"
                  :value="row.declare_status"
                  style="margin: 0 auto"
                  v-else
                ></c_status>
              </td>
              <td style="white-space: nowrap">
                <div
                  v-if="row.withholding_agent_name"
                  :data-type="row.withholding_agent_type == 1 ? '供' : '扣'"
                  :style="{
                    '--dynamic-color':
                      row.withholding_agent_type == 1 ? '#1e90ff' : '#ffa500',
                  }"
                  class="withholding-badge"
                >
                  {{ row.withholding_agent_name }}
                </div>
                <text v-else>-</text>
              </td>
              <td
                style="white-space: nowrap; text-align: center"
                v-for="item in state.templateSortFields.filter(
                  (w) => !state.hideColumns.includes(w.name),
                )"
                :key="item"
              >
                {{ row[item.field] || "-" }}
              </td>
              <td
                style="white-space: nowrap; text-align: center"
                v-if="$judge_auth(['667', '668'])"
              >
                <el-button
                  type="primary"
                  link
                  icon="Edit"
                  @click.stop="
                    state.selectItem = row;
                    state.showEdit = true;
                  "
                  v-if="$judge_auth('668')"
                >
                  编辑
                </el-button>
                <el-button
                  type="danger"
                  link
                  icon="Delete"
                  @click.stop="onDelete(row)"
                  v-if="$judge_auth('667')"
                >
                  删除
                </el-button>
              </td>
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <td colspan="2" style="text-align: left">本页合计</td>
              <td v-for="item in state.statistics" :key="item">
                {{ item }}
              </td>
            </tr>
            <tr>
              <td colspan="2" style="text-align: left">总合计</td>
              <td v-for="item in state.totalStatistics" :key="item">
                {{ item }}
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
    <c_page
      :total="state.totalCount"
      :pageIndex="state.params.page"
      :pageSize="state.params.limit"
      @onLoad="
        (page) => {
          state.params.page = page.pageIndex;
          state.params.limit = page.pageSize;
          onLoad();
        }
      "
    />
  </div>
  <transition name="el-zoom-in-center">
    <c_popup
      v-if="state.showYhdk"
      title="认领到款"
      @close="state.showYhdk = false"
    >
      <c_PayrollBankCollected
        @close="state.showYhdk = false"
        :payroll_id="props.payroll_id"
        :payroll_order_id="props.model?.order_id"
        :customer_id="props.model?.customer_id"
        :customer_name="props.model?.customer_name"
      ></c_PayrollBankCollected>
    </c_popup>
  </transition>
  <transition name="el-zoom-in-center">
    <c_popup
      v-if="state.showEdits"
      title="批量编辑员工"
      @close="state.showEdits = false"
    >
      <c_PayrollEdits
        v-if="state.showEdits"
        :payroll_id="props.payroll_id"
        :ids="state.selectIds"
        @success="onEditsSuccess"
      ></c_PayrollEdits>
    </c_popup>
  </transition>
  <transition name="el-zoom-in-center">
    <c_popup
      v-if="state.showEdit"
      title="编辑员工"
      @close="state.showEdit = false"
    >
      <c_PayrollEdit
        v-if="state.showEdit"
        :item="state.selectItem"
        :templateSortFields="state.templateSortFields"
        :payroll_id="props.payroll_id"
        @success="
          state.showEdit = false;
          onLoad();
        "
      ></c_PayrollEdit>
    </c_popup>
  </transition>
  <el-dialog
    v-model="state.showImport"
    title="导入工资表"
    style="min-width: 300px; width: 30%"
    align-center
    :close-on-click-modal="false"
  >
    <c_PayrollImport
      v-if="state.showImport"
      :payroll_id="props.payroll_id"
      :customer_id="props.model?.customer_id"
      @success="onImportSuccess"
    ></c_PayrollImport>
  </el-dialog>
  <el-dialog
    v-model="state.showError"
    title="异常处理"
    width="70%"
    align-center
  >
    <c_PayrollError
      v-if="state.showError"
      :payroll_id="props.payroll_id"
      @success="onErrorSuccess"
    ></c_PayrollError>
  </el-dialog>
  <el-dialog v-model="state.showPay" title="申请发薪" width="60%" align-center>
    <c_PayrollPay
      v-if="state.showPay"
      :payroll_id="props.payroll_id"
      :belonger_id="props.model?.belonger_id"
      :belonger_department_id="props.model?.belonger_department_id"
      :pay_date="props.model?.pay_date"
      :ids="state.selectIds"
      @success="onPaySuccess"
      @close="state.showPay = false"
    ></c_PayrollPay>
  </el-dialog>
  <el-dialog
    v-model="state.showSetAgent"
    title="批量设置扣缴义务人"
    width="400px"
    align-center
  >
    <el-cascader
      v-model="state.setAgentModel.withholding_agent_uid"
      :options="state.withholding_agent_data"
      :props="{ value: 'uid', label: 'name' }"
      placeholder="扣缴义务人"
      filterable
      clearable
      @change="onSetAgentChange"
      style="width: 100%"
    />
    <el-select
      v-model="state.setAgentModel.settle_unit_id"
      placeholder="--结算单位--"
      size="large"
      style="width: 100%; margin-top: 20px"
      v-if="state.setAgentModel.withholding_agent_type == 1"
    >
      <el-option
        v-for="item in state.settleunitData"
        :key="item.id"
        :label="item.name"
        :value="item.id"
      />
      <template #footer>
        <el-button size="small" @click="onLoadSettleUnit()">刷新</el-button>
      </template>
    </el-select>
    <div
      style="
        display: flex;
        align-items: center;
        justify-content: flex-end;
        margin-top: 20px;
      "
    >
      <el-button @click="state.showSetAgent = false">取消</el-button>
      <el-button type="primary" @click="onSetAgentSubmit">提交</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { onMounted, reactive, ref } from "vue";
import {
  payrollemployee_list,
  payrollemployee_save,
  payrollemployee_delete,
  payrollemployee_declare,
  payrollemployee_getcount_tax,
  payrollemployee_getcount_pay,
  payrollemployee_getcount_error,
  payrollemployee_applycalctax,
  payrollemployee_setwithholdingagent,
  payrollemployee_cancelcalctax,
  payrollemployee_export,
} from "@/http/payrollemployee";
import { ElMessage, ElMessageBox } from "element-plus";
import { priceFormat } from "@/utils/qFormat";
import {
  data_withholdingagent_supplier_select,
  data_settleunit_select,
} from "@/http/data";
import store from "@/store";
import { onCopy } from "@/utils/qFormat";

export default {
  props: {
    payroll_id: Number,
    model: Object,
  },
  setup(props, { emit }) {
    const tableDom = ref(null);
    const state = reactive({
      params: {
        limit: 100,
        page: 1,
      },
      statistics: [],
      templateSortFields: [],
      selectFile: {},
      withholding_agent: {},
      setAgentModel: {},
      selectIds: [],
      hideColumns: ["序号", "姓名", "是否外协", "扣缴义务人"],
      column_name_width: 80,
    });
    onMounted(() => {
      console.log(props);
      
      state.params.payroll_id = props.payroll_id;
      onFirst();
    });

    const onFirst = () => {
      payrollemployee_getcount_tax({
        payroll_id: props.payroll_id,
        customer_id: props.model?.customer_id,
      }).then((res) => {
        if (res.status == 200) state.taxCount = res.data?.data?.num;
      });

      payrollemployee_getcount_pay({
        payroll_id: props.payroll_id,
        customer_id: props.model?.customer_id,
      }).then((res) => {
        if (res.status == 200) state.payCount = res.data?.data?.num;
      });

      payrollemployee_getcount_error(props.payroll_id).then((res) => {
        if (res.status == 200) state.errorCount = res.data?.data?.num;
      });

      onLoad();
    };

    let sourceList = [];
    const onLoad = () => {
      delete state.tableData;

      if (state.declare_status?.length > 0)
        state.params.declare_status = state.declare_status.join(",");
      else delete state.params.declare_status;

      payrollemployee_list(state.params).then((res) => {
        if (res.status == 200) {
          const {
            count,
            list,
            page_statistics,
            statistics,
            templateSortFields,
          } = res.data.data;
          sourceList = JSON.parse(JSON.stringify(list));
          state.totalCount = count;
          state.tableData = list;
          state.templateSortFields = templateSortFields;

          let tjArr = [];
          const keys = Object.keys(page_statistics);
          keys.forEach((key) => {
            const index = state.templateSortFields.findIndex(
              (w) => w.field == key,
            );

            if (index > -1)
              tjArr[index + 1] = priceFormat(page_statistics[key]);
          });
          tjArr.length = tjArr.length + 7;
          state.statistics = tjArr;

          let tjArr2 = [];
          const keys2 = Object.keys(statistics);
          keys2.forEach((key) => {
            const index = state.templateSortFields.findIndex(
              (w) => w.field == key,
            );
            if (index > -1) tjArr2[index + 1] = priceFormat(statistics[key]);
          });
          tjArr2.length = tjArr2.length + 7;
          state.totalStatistics = tjArr2;

          state.selectIds = [];
          var maxName = list
            .map((m) => m.name)
            .reduce((a, b) => (a.length > b.length ? a : b));
          if (maxName.length > 3) {
            state.column_name_width = maxName.length * 15;
          }
        }
      });
    };

    //排序
    const onSortChange = (field) => {
      if (state.params.sort_field == field) {
        if (!state.params.sort_value) {
          state.params.sort_value = "asc";
        } else if (state.params.sort_value == "asc") {
          state.params.sort_value = "desc";
        } else {
          delete state.params.sort_field;
          delete state.params.sort_value;
        }
      } else {
        state.params.sort_field = field;
        state.params.sort_value = "asc";
      }

      onLoad();
    };

    //重置查询条件
    const onReset = () => {
      state.params = { payroll_id: props.payroll_id };
      state.key = Math.random();
      delete state.withholding_agent_uid;
      delete state.declare_status;
      onLoad();
    };

    //清空查询条件
    const onClearParams = () => {
      state.params = {
        payroll_id: props.payroll_id,
        page: state.params.page,
        limit: state.params.limit,
      };
      state.key = Math.random();
      delete state.withholding_agent_uid;
      delete state.declare_status;
    };

    //批量修改
    const onEdits = () => {
      if (state.selectIds?.length <= 0) {
        ElMessage({
          type: "warning",
          message: "请选择要操作的数据！",
          grouping: true,
        });
        return false;
      }
      state.showEdits = true;
    };

    //删除
    const onDelete = (item) => {
      ElMessageBox.confirm(
        `您确定将员工<strong style='color:#1e90ff'>${item.name}</strong>从本工资表中<text style='color:#f00'>移除</text>吗？`,
        "删除",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          dangerouslyUseHTMLString: true,
          type: "warning",
        },
      ).then(() => {
        payrollemployee_delete({
          id: item.id,
          payroll_id: props.payroll_id,
        }).then((res) => {
          if (res.status == 200) {
            ElMessage.success(res.data.msg);
            onFirst();
            emit("onLoad");
          }
        });
      });
    };

    //批量删除
    const onDeletes = () => {
      if (state.selectIds?.length <= 0) {
        ElMessage({
          type: "warning",
          message: "请选择要操作的数据！",
          grouping: true,
        });
        return false;
      }

      ElMessageBox.confirm(
        `您确定<text style='color:#f00'>删除</text>已选<strong style='color:#f00'>${state.selectIds?.length}人</strong>的工资数据吗？`,
        "删除",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          dangerouslyUseHTMLString: true,
          type: "warning",
        },
      ).then(() => {
        payrollemployee_delete({
          id: state.selectIds.join(","),
          payroll_id: props.payroll_id,
        }).then((res) => {
          if (res.status == 200) {
            ElMessage.success(res.data.msg);
            onFirst();
            emit("onLoad");
          }
        });
      });
    };

    const onDeclares = () => {
      if (state.selectIds?.length <= 0) {
        ElMessage({
          type: "warning",
          message: "请选择要操作的数据！",
          grouping: true,
        });
        return false;
      }

      ElMessageBox.confirm(
        `您确定<text style='color:#1e90ff'>报送</text>已选<strong style='color:#f00'>${state.selectIds?.length}人</strong>的工资数据吗？`,
        "报送",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          dangerouslyUseHTMLString: true,
          type: "warning",
        },
      ).then(() => {
        payrollemployee_declare(state.selectIds.join(",")).then((res) => {
          if (res.status == 200) {
            ElMessage.success(res.data.msg);
            onFirst();
            emit("onLoad");
          }
        });
      });
    };

    const onRowClick = (id) => {
      // tableDom.value.toggleRowSelection(row);
      const index = state.selectIds.findIndex((w) => w == id);
      if (index > -1) {
        state.selectIds.splice(index, 1);
      } else {
        state.selectIds.push(id);
      }
    };

    const onSuanShui = () => {
      if (state.selectIds?.length <= 0) {
        ElMessage({
          type: "warning",
          message: "请选择要操作的数据！",
          grouping: true,
        });
        return false;
      }

      ElMessageBox.confirm(
        `您本次选择了<strong style='color:#f00'>${state.selectIds?.length}</strong>条数据，是否立即提交<strong style='color:#ffa500'>算税</strong>申请？`,
        "算税提醒",
        {
          dangerouslyUseHTMLString: true,
          confirmButtonText: "立即提交",
          cancelButtonText: "取消",
          type: "warning",
        },
      ).then(() => {
        const data = {
          payroll_id: props.payroll_id,
          id: state.selectIds.join(","),
        };
        payrollemployee_applycalctax(data)
          .then((res) => {
            if (res.status == 200) {
              ElMessageBox.alert(res.data.msg, "成功", {
                type: "success",
                confirmButtonText: "确定",
                callback: () => {
                  onFirst();
                },
              });
            } else {
              ElMessageBox.alert(res.data.msg, "错误", {
                type: "error",
                confirmButtonText: "确定",
                callback: () => {
                  onFirst();
                },
              });
            }
          })
          .catch((err) => {
            ElMessageBox.alert(err.data.msg, "错误", {
              type: "error",
              confirmButtonText: "确定",
              callback: () => {
                onFirst();
              },
            });
          });
      });
    };

    //申请发薪
    const onPay = () => {
      if (state.selectIds?.length <= 0) {
        ElMessage({
          type: "warning",
          message: "请选择要操作的数据！",
          grouping: true,
        });
        return false;
      }
      state.showPay = true;
    };

    const onSubmit = (row) => {
      payrollemployee_save({
        payroll_id: props.payroll_id,
        data: JSON.stringify([row]),
      }).then((res) => {
        if (res.status == 200) {
          ElMessage.success(res.data.msg);
          onFirst();
        }
      });
      row.isEdit = false;
    };

    const onPaySuccess = () => {
      onFirst();
      emit("onLoad");
      state.showPay = false;
    };

    const onCancel = (index) => {
      state.tableData[index] = JSON.parse(JSON.stringify(sourceList[index]));
    };

    const onEditsSuccess = () => {
      onFirst();
      emit("onLoad");
      state.showEdits = false;
    };

    const onImportSuccess = (showError) => {
      onFirst();
      emit("onLoad");
      state.showImport = false;
      state.showError = showError;
    };

    const onErrorSuccess = () => {
      onFirst();
      emit("onLoad");
      state.showError = false;
    };

    const onShowSetAgent = () => {
      if (state.selectIds?.length <= 0) {
        ElMessage({
          type: "warning",
          message: "请选择要操作的数据！",
          grouping: true,
        });
        return false;
      }
      onLoadWithholdingAgent();
      state.showSetAgent = true;
      state.setAgentModel = {};
    };

    //加载扣缴义务人和供应商
    const onLoadWithholdingAgent = () => {
      data_withholdingagent_supplier_select().then((res) => {
        if (res.status == 200) {
          const { withholdingAgent, supplier } = res.data.data;
          state.withholding_agent_data = [
            {
              uid: 0,
              name: "扣缴义务人",
              children: withholdingAgent.list.map((m) => {
                return { uid: "k_" + m.id, ...m };
              }),
            },
            {
              uid: 1,
              name: "供应商",
              children: supplier.list.map((m) => {
                return { uid: "g_" + m.id, ...m };
              }),
            },
          ];
        }
      });
    };

    const onSetAgentChange = (value) => {
      if (value?.length == 2) {
        state.setAgentModel.withholding_agent_type = value[0];
        state.setAgentModel.withholding_agent_uid = value[1];
        state.setAgentModel.withholding_agent_id = value[1].substring(2);

        delete state.setAgentModel.settle_unit_id;
        data_settleunit_select(state.setAgentModel.withholding_agent_id).then(
          (res) => {
            if (res.status == 200) state.settleunitData = res.data.data?.list;
          },
        );
      }
    };

    const onSetAgentSubmit = () => {
      if (!state.setAgentModel?.withholding_agent_id) {
        ElMessage({
          type: "warning",
          message: "请选择扣缴义务人",
          grouping: true,
        });
        return false;
      }

      if (
        state.setAgentModel?.withholding_agent_type == 1 &&
        !state.setAgentModel?.settle_unit_id
      ) {
        ElMessage({
          type: "warning",
          message: "请选择结算单位",
          grouping: true,
        });
        return false;
      }

      const data = {
        payroll_id: props.payroll_id,
        id: state.selectIds.join(","),
        withholding_agent_type: state.setAgentModel?.withholding_agent_type,
        withholding_agent_id: state.setAgentModel?.withholding_agent_id,
        settle_unit_id: state.setAgentModel?.settle_unit_id,
      };

      payrollemployee_setwithholdingagent(data).then((res) => {
        if (res.status == 200) {
          ElMessage.success(res.data.msg);
          onLoad();
          emit("onLoad");
          state.showSetAgent = false;
        }
      });
    };

    const onAllChecked = (item) => {
      const { checked } = item.target;
      if (checked) {
        state.selectIds = state.tableData?.map((m) => m.id);
      } else {
        state.selectIds = [];
      }
      state.key = Math.random();
    };

    const onCanelSuanShui = () => {
      if (state.selectIds?.length <= 0) {
        ElMessage({
          type: "warning",
          message: "请选择要操作的数据！",
          grouping: true,
        });
        return false;
      }

      ElMessageBox.confirm(
        `您本次选择了<strong style='color:#f00'>${state.selectIds?.length}</strong>条数据，是否立即提交<strong style='color:#ffa500'>取消算税</strong>申请？`,
        "取消算税",
        {
          dangerouslyUseHTMLString: true,
          confirmButtonText: "立即提交",
          cancelButtonText: "取消",
          type: "warning",
        },
      ).then(() => {
        const data = {
          payroll_id: props.payroll_id,
          id: state.selectIds.join(","),
        };
        payrollemployee_cancelcalctax(data).then((res) => {
          if (res.status == 200) {
            ElMessage.success(res.data.msg);
            onFirst();
          }
        });
      });
    };

    const onExport = () => {
      let params = JSON.parse(JSON.stringify(state.params));
      params.limit = 0;
      payrollemployee_export({ payroll_id: props.payroll_id })
        .then((res) => {
          let fileName = decodeURI(
            res.headers["content-disposition"].split("=")[1],
          );

          //通过后台返回 的word文件流设置文件名并下载
          var blob = new Blob([res.data], {
            type: res.data.type,
          });
          var downloadElement = document.createElement("a");
          var href = window.URL.createObjectURL(blob); //创建下载的链接
          downloadElement.href = href;
          downloadElement.download = fileName; //下载后文件名
          document.body.appendChild(downloadElement);
          downloadElement.click(); //点击下载
          document.body.removeChild(downloadElement); //下载完成移除元素
          window.URL.revokeObjectURL(href); //释放掉blob对象
        })
        .catch((err) => {
          const fileReader = new FileReader();
          fileReader.readAsText(
            new Blob([err.data], { type: "application/octet-stream" }),
            "utf-8",
          );
          fileReader.onload = () => {
            const msg = JSON.parse(fileReader.result);
            ElMessage.error(msg?.msg);
          };
        });
    };

    const toSuanShui = () => {
      ElMessageBox.confirm(`您即将跳转到算税记录，是否确认？`, "跳转确认", {
        dangerouslyUseHTMLString: true,
        confirmButtonText: "确认",
        cancelButtonText: "取消",
      }).then(() => {
        store.commit("openMenu", {
          path: "CalcTaxList",
          title: "算税记录",
          data: {
            refresh: true,
            keywords: props.model?.order_id,
          },
        });
      });
    };

    const toFaXin = () => {
      ElMessageBox.confirm(`您即将跳转到发薪审核，是否确认？`, "跳转确认", {
        dangerouslyUseHTMLString: true,
        confirmButtonText: "确认",
        cancelButtonText: "取消",
      }).then(() => {
        store.commit("openMenu", {
          path: "SalaryApplyList",
          title: "发薪审核",
          data: {
            refresh: true,
            keywords: props.model?.order_id,
          },
        });
      });
    };

    const onCopyColumns = (field) => {
      const data = state.tableData.map((m) => m[field])?.join(",");
      onCopy(data);
    };

    return {
      state,
      tableDom,
      props,
      onLoad,
      onSortChange,
      onEdits,
      onDelete,
      onDeletes,
      onSubmit,
      onRowClick,
      onCancel,
      onEditsSuccess,
      onImportSuccess,
      onErrorSuccess,
      onSuanShui,
      onPay,
      onPaySuccess,
      onShowSetAgent,
      onSetAgentChange,
      onSetAgentSubmit,
      onReset,
      onAllChecked,
      onCanelSuanShui,
      onExport,
      onDeclares,
      toSuanShui,
      toFaXin,
      onClearParams,
      onCopyColumns,
    };
  },
};
</script>
<style lang="less" scoped>
.payroll-dialog {
  .el-dialog__body {
    flex: 1;
    overflow: hidden;
  }
}

.table-container::-webkit-scrollbar {
  width: 15px;
  height: 15px;
}

.table-container::-webkit-scrollbar-thumb {
  border-radius: 8px;
  background-color: #61b0f5;
}

.table-container::-webkit-scrollbar-track {
  border-radius: 8px;
  background-color: transparent;
}

.table-container {
  min-height: 100px;
  overflow-y: auto; /* 垂直滚动条 */
  display: block; /* 或者使用 overflow: scroll; */
  border: 1px solid #ebeef5;
  font-size: 14px;
  color: #606266;

  table {
    width: 100%; /* 或者具体的宽度 */
    border-collapse: separate; /* 合并边框 */
    position: relative;
  }

  thead th {
    position: sticky; /* 使表头固定 */
    top: 0; /* 固定在顶部 */
    z-index: 1; /* 确保表头在其他内容之上 */
    background-color: #fff;
    border-bottom: 1px solid #ebeef5;
    color: #909399;
  }

  th,
  td {
    position: -webkit-sticky; /* Safari */
    position: sticky;
  }

  /* 固定第一列 */
  thead th:first-child,
  tbody td:first-child {
    width: 40px;
    overflow: hidden;
    white-space: nowrap;
    text-align: center;
    cursor: pointer;
  }

  /* 固定第一列 */
  thead th:nth-child(2),
  tbody td:nth-child(2) {
    width: 70px;
    overflow: hidden;
    white-space: nowrap;
  }

  /* 固定第三列 */
  thead th:nth-child(3),
  tbody td:nth-child(3) {
    width: attr(data-width px, 80px);
    overflow: hidden;
  }

  /* 固定第一列 */
  thead > tr > th {
    &:first-child {
      top: 0;
      left: 0;
      z-index: 10;
      background-color: #fff;
    }
    &:nth-child(2) {
      top: 0;
      left: 40px;
      z-index: 10; /* 确保在最上层 */
      background-color: #fff;
      text-align: left;
    }
    &:nth-child(3) {
      top: 0;
      left: 110px;
      z-index: 10; /* 确保在最上层 */
      background-color: #fff;
      text-align: left;
    }
    &:last-child {
      top: 0;
      right: 0;
      z-index: 10; /* 确保在最上层 */
      background-color: #fff;
    }
  }

  tbody > tr:last-child > td {
    border-bottom: 0 !important;
  }

  tbody > tr > td {
    border-bottom: 1px solid #ebeef5;

    &:first-child {
      left: 0;
      z-index: 2; /* 确保在最上层 */
      background-color: #fff;
      border-bottom: 1px solid #ebeef5;
    }
    &:nth-child(2) {
      top: 0;
      left: 40px;
      z-index: 2; /* 确保在最上层 */
      background-color: #fff;
    }
    &:nth-child(3) {
      top: 0;
      left: 110px;
      z-index: 2; /* 确保在最上层 */
      background-color: #fff;
    }
    &:last-child {
      right: 0;
      z-index: 2; /* 确保在最上层 */
      background-color: #fff;
    }
  }

  tfoot > tr {
    height: 30px;

    &:first-child {
      position: sticky; /* 使表头固定 */
      bottom: 30px;
      overflow: hidden;
      z-index: 10; /* 确保在最上层 */

      & > td {
        border-top: 1px solid #ebeef5;
      }
    }

    &:last-child {
      position: sticky; /* 使表头固定 */
      bottom: 0;
      z-index: 10; /* 确保在最上层 */
      & > td {
        border-top: 1px solid #ebeef5;
      }
    }

    & > td {
      background-color: rgb(246, 246, 246);
      text-align: center;
      padding-top: 5px;
      padding-bottom: 5px;

      &:first-child {
        left: 0;
        z-index: 2; /* 确保在最上层 */
        border-bottom: 1px solid #ebeef5;
      }

      &:nth-child(2) {
        top: 0;
        left: 110px;
        z-index: 10; /* 确保在最上层 */
      }

      &:last-child {
        top: 0;
        right: 0;
        z-index: 10; /* 确保在最上层 */
      }
    }
  }
}
</style>
